"use strict";
/** state: Final **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var trackMetric_1 = require("../../metrics/trackMetric");
var prop_types_1 = require("../../types/prop.types");
var FontAwesome_1 = require("../FontAwesome");
var IconWrapper_1 = require("../IconWrapper");
var utils_1 = require("../utils");
var CLASS_NAME = 'i-link';
var Link = (function (_a) {
    var className = _a.className, download = _a.download, href = _a.href, icon = _a.icon, iconName = _a.iconName, label = _a.label, metricOptions = _a.metricOptions, onClick = _a.onClick, target = _a.target, type = _a.type, restProps = __rest(_a, ["className", "download", "href", "icon", "iconName", "label", "metricOptions", "onClick", "target", "type"]);
    if (href) {
        href = utils_1.removeHrefJavascriptUrl(href);
    }
    var external = href &&
        (href.indexOf('https://') === 0 || href.indexOf('http://') === 0) &&
        href.indexOf(window.location.origin) < 0;
    var rel = target === prop_types_1.AnchorTarget.Blank && external
        ? 'noopener noreferrer'
        : null;
    var handleClick = function (event) {
        if (onClick) {
            if (href === '#') {
                event.preventDefault();
            }
            onClick(event);
        }
    };
    return iconName || icon ? (React.createElement("span", __assign({ className: classNames(CLASS_NAME + "--has-icon", className), onClick: trackMetric_1.trackMetric(metricOptions, handleClick) }, restProps),
        React.createElement("a", { className: CLASS_NAME, download: download, href: href, rel: rel, target: target, type: type }, label),
        icon && React.createElement(IconWrapper_1.IconWrapper, null, icon),
        iconName && (React.createElement(IconWrapper_1.IconWrapper, null,
            React.createElement(FontAwesome_1.FontAwesome, { name: iconName }))))) : (React.createElement("a", __assign({ className: classNames(CLASS_NAME, className), download: download, href: href, onClick: trackMetric_1.trackMetric(metricOptions, handleClick), rel: rel, target: target, type: type }, restProps), label));
});
exports.Link = Link;
Link.Target = prop_types_1.AnchorTarget;
//# sourceMappingURL=Link.js.map